export const WORK_EXPERIENCE_TO = 'work_experience_to';
export const EDUCATION_TO = 'education_to';
export const VOLUNTEER_WORK_TO = 'volunteer_work_to';
export const CERTIFICATIONS_TO = 'certifications_to';
export const PROJECTS_TO = 'projects_to';
export const LEADERSHIP_TO = 'leadership_to';
export const ASSOCIATIONS_TO = 'associations_to';

export const toDates = {
  WORK_EXPERIENCE_TO,
  EDUCATION_TO,
  VOLUNTEER_WORK_TO,
  CERTIFICATIONS_TO,
  PROJECTS_TO,
  LEADERSHIP_TO,
  ASSOCIATIONS_TO,
};
